// NPM Imports

// Helpers

// Internal imports
import HeaderNav from "./HeaderNav";
import Slider from "./HeroSlider";
import Accordion from "./Accordion";
import ScrollTop from "./ScrollTop";

/**
 * Main App module used in index.js to initialise all other modules, includes helper
 * functions/modules for use in initialising modules depending on various criteria
 *
 * @returns {{init: init}}
 */

const App = (() => {
  const loadedModules = {};

  /**
   * @param Module {Object}
   * @param Module.init {Function}
   * @param name {string|boolean}
   * @param options {Object}
   */
  const alwaysInit = (Module, name = false, options = false) => {
    if (name) {
      loadedModules[name] = Module;
    }
    Module.init(options);
  };

  const init = () => {
    alwaysInit(HeaderNav, "HeaderNav");
    alwaysInit(Slider, "HeroSlider", [
      {
        containerClass: 'hero-image__container',
        sliderClass: 'hero-image__slider',
        nextClass: 'hero-image__next',
        prevClass: 'hero-image__prev',
        dotsClass: 'hero-image__nav--dot'
      }
    ]);
    alwaysInit(Accordion, "Accordion");
    alwaysInit(ScrollTop, "ScrollTop");
  };

  return {
    init
  };
})();

export default App;
